import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { AccountDayEquipmentTypeStat } from '~hooks/useAccount/models';

// The vendor card sits in a fixed-height virtualized row, so the rows scroll instead of overflowing it.
const EQUIPMENT_TYPE_STAT_ROWS_MAX_HEIGHT_IN_PX = 60;

interface EquipmentTypeStatRowsProps {
  equipmentTypeStats: AccountDayEquipmentTypeStat[];
}

export default function EquipmentTypeStatRows({
  equipmentTypeStats,
}: EquipmentTypeStatRowsProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.25,
        maxHeight: `${EQUIPMENT_TYPE_STAT_ROWS_MAX_HEIGHT_IN_PX}px`,
        overflowY: 'auto',
      }}
      data-ui="equipment-type-stat-rows"
    >
      {equipmentTypeStats.map((stat) => (
        <Box
          key={stat.id}
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 0.5,
            justifyContent: 'space-between',
          }}
          data-ui="equipment-type-stat-row"
        >
          <Typography
            noWrap
            variant="body2"
            sx={{ color: theme.brandV2.colors.treadGray2 }}
          >
            {stat.equipmentType.name}
          </Typography>

          <Tooltip
            title={t('form_fields.assigned_of_committed_trucks', {
              assigned: stat.assignedCount,
              committed: stat.committedCount,
            })}
          >
            <Typography
              variant="body2"
              sx={{ color: theme.brandV2.colors.treadBlack, fontWeight: 600 }}
            >
              {`${stat.assignedCount} / ${stat.committedCount}`}
            </Typography>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
}
